import { Fragment, useState, useEffect } from "react";
import InputMask from "react-input-mask";
import "./cotizatuhibrido.css";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Enviar from "../../images/assets/enviar.png";
import Swal from "sweetalert2";
import cuid from "cuid";
import Spinner from "../spinner/Spinner";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";
// Modelo
import grandi10sedanImg from "../../images/colores/1001/2.webp";
import ioniqImg from "../../images/colores/1005/3.webp";
import grandi10hbImg from "../../images/colores/1038/3.webp";
import santafeImg from "../../images/colores/1023/3.webp";
import konaImg from "../../images/colores/1035/3.webp";
import NuevoAccentImg from "../../images/colores/1036/2.webp";
import StariaImg from "../../images/colores/1037/2.webp";
import KonaElectricoImg from "../../images/colores/1039/10000634.webp";
import { Server, tipoInteresado } from "../../constants";
import { verificarCedula } from 'udv-ec';
import queryString from 'query-string';

function FormCotizaTuHibrido({ datos }) {
    const history = useHistory();
    const [modeloNombre, setModeloNombre] = useState(datos.match.params.modelo);
    const [modelo, setModelo] = useState(0);
    const [imagen, setImagen] = useState(null);
    const [colores, setColores] = useState([]);
    const [tipoVehiculo, setTipoVehiculo] = useState(0);
    const [ciudades, setCiudades] = useState([]);
    const [ciudad, setCiudad] = useState("0");
    const [versiones, setVersiones] = useState([]);
    const [version, setVersion] = useState("0");
    const [anio, setAnio] = useState("0");
    const [precio, setPrecio] = useState("0");
    const [bono, setBono] = useState(0);
    const [precioFinal, setPreciofinal] = useState("0");
    const [concesionarios, setConcesionarios] = useState([]);
    const [concesionario, setConcesionario] = useState("0");
    const [empresa, setEmpresa] = useState(0);
    const [almacen, setAlmacen] = useState(0);
    const [nombre, setNombre] = useState("");
    const [apellido, setApellido] = useState("");
    const [cedula, setCedula] = useState("");
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const [vehiculoColor, setVehiculoColor] = useState(0);
    const [colorNombre, setColorNombre] = useState("");
    const [acepto, setAcepto] = useState(true);
    const [activeSpinner, setActiveSpinner] = useState(false);
    const [versionNombre, setVersionNombre] = useState("");
    const [ciudadNombre, setCiudadNombre] = useState("");
    const [concesionarioNombre, setConcesionarioNombre] = useState("");
    const [contactoNombre, setContactoNombre] = useState("");
    const [contactoEmail, setContactoEmail] = useState("");
    const [contactoTelefono, setContactoTelefono] = useState("");
    const [concesionarioDireccion, setConcesionariodireccion] = useState("");
    const [concesionarioHorario, setConcesionariohorario] = useState("");
    const [concesionarioHorarioFs, setConcesionariohorariofs] = useState("");
    const [concesionarioTelefono, setConcesionariotelefono] = useState("");
    const [token, setToken] = useState("");
    const [agenciaIdSGC, setAgenciaIdSGC] = useState(0);
    const [modeloSGCId, setModeloSGCId] = useState(0);
    const [versionSGC, setVersionSGC] = useState(0); 
    const [utmSource, setUtmSource] = useState("");
    const [utmMedium, setUtmMedium] = useState("");
    const [utmCampaign, setUtmCampaign] = useState("");
    const [utmTerm, setUtmTerm] = useState("");
    const [utmContent, setUtmContent] = useState("");
    const [tokenBunker, setTokenBunker] = useState("");
    // Cambios
    const emailRegex = new RegExp(
        "^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$"
    );
    const celularRegex = new RegExp("[0]{1}[8-9]{1}[0-9]{8}");
    const letrasRegex = new RegExp("^[ A-Za-z]+$");

    const leerVersion = async (e) => {
        const versionInfo = e.target.value;
        const versionNombre = e.target.options[e.target.selectedIndex].text;
        setVersionNombre(versionNombre);
        const infoFinal = versionInfo.split("|");
        setVersion(infoFinal[0]);
        setModelo(infoFinal[6]);
        /*
        * Se agrega el id de la version
        * Date:07/12/21*/
        setModeloSGCId(infoFinal[5]);
        // Get Colores
        const getColores = async (modeloEnviar, versionEnviar) => {
            const url = `${Server}/api/modelo_colores/${modeloEnviar}/${versionEnviar}`;
            const resultado = await axios.get(url);
            setColores(resultado.data);
            setVehiculoColor(resultado.data[0].VAC_COLOR);
            setColorNombre(resultado.data[0].COL_NOMBRE);
            let imgColor = require(`../../images/colores/${modeloEnviar}/${resultado.data[0].VAC_COLOR}.webp`);
            setImagen(imgColor);
        };
        getColores(infoFinal[6], infoFinal[0]);
        // Get Anios
        const getAniosPrecios = async (version) => {
            const url = `${Server}/api/version_anio/${version}/1`;
            const resultado = await axios.get(url);
            setVersion(resultado.data[0].VEA_VERSION);
            setAnio(resultado.data[0].VEA_ANIO);
            setPrecio(resultado.data[0].VEA_PRECIO_PVP);
            setBono(parseInt(resultado.data[0].VEA_BONO));
            setPreciofinal(resultado.data[0].VEA_PRECIO_FINAL);
            setVersionSGC(resultado.data[0].VERSION_SGC);
        };
        await getAniosPrecios(infoFinal[0]);
    };

    const blurCedula = (e) => {
        let cedula = e.target.value.replace(" ", "");
        let identificacionVálida = false;
        identificacionVálida = verificarCedula(cedula);
        if (!identificacionVálida) {
            Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "El campo identificación es incorrecto",
                showConfirmButton: false,
                timer: 1500,
            });
            setCedula("");
            document.getElementById("cedula").value = "";
        }
    };

    const coloresModelos = (color_codigo, color_nombre) => {
        let imgColor = require(`../../images/colores/${modelo}/${color_codigo}.webp`);
        setImagen(imgColor);
        setVehiculoColor(color_codigo);
        setColorNombre(color_nombre);
    };

    const leerAcepto = (e) => {
        setAcepto(e.target.checked);
    };

    const leerCiudad = async (e) => {
        setCiudad(e.target.value);
        setCiudadNombre(e.target.options[e.target.selectedIndex].text);
        // Get Concesionario
        const ciudadEnviar = document.getElementById("ciudad").value;
        if (ciudadEnviar === "") {
            setConcesionarios([]);
            return;
        }
        const url = `${Server}/api/concesionarios/1/1-3/2/${ciudadEnviar}`;
        const resultado = await axios.get(url);
        setConcesionarios(resultado.data);
    };

    const leerConcesionario = async (e) => {
        setConcesionario(e.target.value);
        setConcesionarioNombre(e.target.options[e.target.selectedIndex].text);
        const concesionarioEnviar = document
            .getElementById("concesionario")
            .value.split("|");
        if (concesionarioEnviar === "") {
            return;
        }
        setEmpresa(concesionarioEnviar[0]);
        setAlmacen(concesionarioEnviar[1]);
        setConcesionariodireccion(concesionarioEnviar[2]);
        setConcesionariotelefono(concesionarioEnviar[3]);
        setConcesionariohorario(concesionarioEnviar[4]);
        setConcesionariohorariofs(concesionarioEnviar[5]);
        /*
        *Variable Consecionario SGC
        * 07/12/2021*/
        setAgenciaIdSGC(concesionarioEnviar[7])
        let emp = concesionarioEnviar[0];
        let alm = concesionarioEnviar[1];
        // Info Concesionario
        const url = `${Server}/api/concesionario_informacion/${tipoVehiculo}/${emp}/${alm}`;
        const resultado = await axios.get(url);
        if (resultado.data && resultado.data.length > 0) {
            setContactoEmail(resultado.data[0].COA_EMAIL_CONTACTO);
            setContactoNombre(resultado.data[0].COA_CONTACTO);
            setContactoTelefono(resultado.data[0].COA_TEFEFONO);
        } else {
            setContactoEmail("");
            setContactoNombre("");
            setContactoTelefono("");
            // Opcional: podrías mostrar una alerta aquí si lo deseas
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (camposValidos()) {
            setActiveSpinner(true);
            let cid = cuid();
            const dataForm = new FormData();
            dataForm.append("id", cid);
            dataForm.append("ciudad", ciudad);
            dataForm.append("empresa", empresa);
            dataForm.append("almacen", almacen);
            dataForm.append("cedula", cedula);
            dataForm.append("nombre", nombre);
            dataForm.append("apellido", apellido);
            dataForm.append("email", email);
            dataForm.append("telefono", telefono.replaceAll(" ", ""));
            dataForm.append("token", token);
            dataForm.append("tipo_vehiculo", tipoVehiculo);
            dataForm.append("vehiculo_modelo", modelo);
            dataForm.append("vehiculo_modelo_nombre", modeloNombre);
            dataForm.append("vehiculo_version", version);
            dataForm.append("vehiculo_color", vehiculoColor);
            dataForm.append("vehiculo_anio", anio);
            dataForm.append("vehiculo_precio", precio);
            dataForm.append("forma_pago", '');
            dataForm.append("exonerado", 0);
            dataForm.append("porc_discapacidad", 0);
            dataForm.append("porc_desc_discapacidad", 0);
            dataForm.append("version_nombre", versionNombre);
            dataForm.append("color_nombre", colorNombre);
            dataForm.append("ciudad_nombre", ciudadNombre);
            dataForm.append("concesionario_nombre", concesionarioNombre);
            dataForm.append("concesionario_direccion", concesionarioDireccion);
            dataForm.append("concesionario_telefono", concesionarioTelefono);
            dataForm.append("concesionario_horario", concesionarioHorario);
            dataForm.append("concesionario_horariofs", concesionarioHorarioFs);
            dataForm.append("contacto_nombre", contactoNombre);
            dataForm.append("contacto_email", contactoEmail);
            dataForm.append("contacto_telefono", contactoTelefono);
            dataForm.append("token_bunker", tokenBunker);
            //Campos Extras Integracion SGC
            dataForm.append("tipo_documento", "CEDULA");
            dataForm.append("agencia_id_sgc", agenciaIdSGC);
            dataForm.append("modelocomercial_id_sgc", modeloSGCId);
            dataForm.append("tipo_vehiculo_sgc", "VEHICULO LIVIANO");
            dataForm.append("tipo_interesado_sgc", tipoInteresado.PáginaWeb);
            dataForm.append("version_sgc",versionSGC);
            // Campos UTM
            dataForm.append("utm_source", utmSource);
            dataForm.append("utm_medium", utmMedium);
            dataForm.append("utm_campaign", utmCampaign);
            dataForm.append("utm_term", utmTerm);
            dataForm.append("utm_content", utmContent);

         setActiveSpinner(false);
            // Enviar prospecto
            const url = `${Server}/api/cotizador/ingresar_simulador`
            await axios.post(
                url,
                dataForm
            ).then((respuesta) => {
                console.log(respuesta.data.status);
                if (respuesta.data.status === 'Ok') {
                    setActiveSpinner(false)
                    //limpiarDatos();
                    Swal.fire({
                        title: "ÉXITO",
                        text: "La información fue enviada con éxito",
                        showCloseButton: true,
                        icon: "success",
                    });
                    history.push(`/cotizador/gracias/${modeloNombre}?cedula=${cedula}`);
                } else {
                    Swal.fire({
                        title: "Información",
                        text: respuesta.data.respuestaSGC.mensaje,
                        showCloseButton: true,
                        icon: "info",
                    });
                    setActiveSpinner(false)
                }    
            }).catch((err) => {
                Swal.fire({
                    title: "Error al enviar la información",
                    text: "Por favor intente en unos minutos",
                    showCloseButton: true,
                    icon: "error",
                });
                setActiveSpinner(false)
            })
        }
    };

    function formEsValido() {
        return nombre && apellido && cedula && email && telefono && ciudadNombre && concesionarioNombre && acepto;
    }

    const camposValidos = () => {
        if (!emailRegex.test(email)) {
            Swal.fire({
                title: "Error",
                text: "El campo Email no tiene el formato Correcto...",
                showCloseButton: true,
                icon: "error",
            });
            return false;
        }
        if (!letrasRegex.test(nombre) || !letrasRegex.test(apellido)) {

            Swal.fire({
                title: "Error",
                text: "El campo Nombre y Apellido solo acepta caracteres Alfabeticos...",
                showCloseButton: true,
                icon: "error",
            });
            return false;
        }
        if (
            !celularRegex.test(telefono.replaceAll(" ", "")) ||
            telefono.replaceAll(" ", "").length !== 10
        ) {
            Swal.fire({
                title: "Error",
                text: "El campo Telefono no tiene el formato Correcto...",
                showCloseButton: true,
                icon: "error",
            });
            return false;
        }
        if (
            version === "0" ||
            ciudad === "0" ||
            concesionario === "0" ||
            agenciaIdSGC === 0 ||
            vehiculoColor === 0
        ) {
            setActiveSpinner(false);
            Swal.fire({
                title: "Error",
                text: "Verifique los Campos de Version, Color, Ciudad o Concesionario...",
                showCloseButton: true,
                icon: "error",
            });
            return false;
        }
        if (acepto === false) {
            Swal.fire({
                title: "Advertencia",
                text: "Por favor, acepte los términos y condiciones",
                showCloseButton: true,
                icon: "warning",
            });
            return false;
        }
        return true;
    };

    const limpiarDatos = () => {
        setCiudad("0");
        setVersion("0");
        setAnio("0");
        setPrecio("0");
        setBono(0);
        setPreciofinal("0");
        setConcesionario("0");
        setEmpresa(0);
        setAlmacen(0);
        setNombre("");
        setApellido("");
        setCedula("");
        setEmail("");
        setTelefono("");
        setVehiculoColor(0);
        setAcepto(false);
        setActiveSpinner(false);
        // Hooks Adds
        setConcesionarioNombre("");
        setConcesionariohorario("");
        setConcesionariohorariofs("");
        setConcesionariotelefono("");
        setConcesionariodireccion("");
        setContactoEmail("");
        setContactoNombre("");
        setContactoTelefono("");
        setColores([]);
        setColorNombre("");
        setVersionNombre("");
        setCiudadNombre("");
        setToken("");
        document.getElementById("formCotizador").reset();
        document.getElementById("labelColor").innerHTML = "";
        document.getElementById("acepto").checked = false;
        document.getElementById("acepto1").checked = false;
        document.getElementById("version").selectedIndex = "0";
        document.getElementById("ciudad").selectedIndex = "0";
        document.getElementById("concesionario").selectedIndex = "0";
    }

    useEffect(() => {
        let modeloEnviar = 0;
        switch (modeloNombre) {
            case "grandi10sedan":
                
                modeloEnviar = 1001;
                setImagen(grandi10sedanImg);
                setTipoVehiculo(1);
                setTokenBunker("b26397bac71e931e42d5a48227ba489a2234ee9e");
                break;
            case "ioniq":
                
                modeloEnviar = 1005;
                setImagen(ioniqImg);
                setTipoVehiculo(1);
                setTokenBunker("");
                break;
            case "nuevo-creta":
                
                modeloEnviar = 1030;
                setTipoVehiculo(1);
                setTokenBunker("e1c650a90b2097a594ca591fc1008a512efec7c6");
                break;
            case "ioniq5":
                
                modeloEnviar = 1040;
                setTipoVehiculo(1);
                setTokenBunker("");
                break;
            case "palisade":
                
                modeloEnviar = 1034;
                setTipoVehiculo(1);
                setTokenBunker("");
                break;
            case "nuevo-tucson":
                
                modeloEnviar = 1031;
                setTipoVehiculo(1);
                setTokenBunker("cce99fa760c4fbcd254f64dab1210f96e49e08d0");
                break;
            case "nuevosantafe":
                
                modeloEnviar = 1023;
                setImagen(santafeImg);
                setTipoVehiculo(1);
                setTokenBunker("8e422eb615c83672c735ff4bde7712566b0b12fc");
                break;
            case "kona":
                
                modeloEnviar = 1035;
                setImagen(konaImg);
                setTipoVehiculo(1);
                setTokenBunker("613a22f1201796c104e062f84903175caf5a5c19");
                break;
            case "nuevo-accent":
                
                modeloEnviar = 1036;
                setImagen(NuevoAccentImg);
                setTipoVehiculo(1);
                setTokenBunker("7ad86ed0636bf79222a1d816def9ade386499792");
                break;
            case "staria":
                
                modeloEnviar = 1037;
                setImagen(StariaImg);
                setTipoVehiculo(1);
                setTokenBunker("7142cb3b6c5556994853ad9c2182da0da76c1efb");
                break;
            case "grandi10hb":
                
                modeloEnviar = 1038;
                setImagen(grandi10hbImg);
                setTipoVehiculo(1);
                setTokenBunker("a3cab38aa85e9a4934b033b4b252a867e1c0429d");
                break;
            case "kona-electrico":
                
                modeloEnviar = 1039;
                setImagen(KonaElectricoImg);
                setTipoVehiculo(1);
                setTokenBunker("613a22f1201796c104e062f84903175caf5a5c1");
                break;
            default:
                break;
        }

        let versionInfo = "";
        // Versiones
        const getVersiones = async () => {
            const url = `${Server}/api/vehiculos/getModelosHibridos`;
            const resultado = await axios.get(url);
            setVersiones(resultado.data.data);
            console.log(versiones);
            document.getElementById("version").value =
                resultado.data[0].VER_CODIGO +
                "|" +
                resultado.data[0].VEA_ANIO +
                "|" +
                resultado.data[0].VEA_PRECIO_PVP +
                "|" +
                resultado.data[0].VEA_BONO +
                "|" +
                resultado.data[0].VEA_PRECIO_FINAL
                +
                "|" +
                resultado.data[0].VER_COD_SGC;
            versionInfo =
                resultado.data[0].VER_CODIGO +
                "|" +
                resultado.data[0].VEA_ANIO +
                "|" +
                resultado.data[0].VEA_PRECIO_PVP +
                "|" +
                resultado.data[0].VEA_BONO +
                "|" +
                resultado.data[0].VEA_PRECIO_FINAL +
                "|" +
                resultado.data[0].VER_COD_SGC +
                "|" +
                resultado.data[0].MOD_CODIGO;
            // Calculo con primera version
            let infoFinal = versionInfo.split("|");
            setVersion(infoFinal[0]);
            setModelo(infoFinal[6]);
            setAnio(infoFinal[1]);
            setPrecio(infoFinal[2]);
            setBono(parseInt(infoFinal[3]));
            setPreciofinal(infoFinal[4]);
            setModeloSGCId(infoFinal[5]);
            setVersionSGC(resultado.data[0].VERSION_SGC)
            // Get Colores
            const getColores = async (modeloEnviar, versionEnviar) => {
                const url = `${Server}/api/modelo_colores/${modeloEnviar}/${versionEnviar}`;
                const resultado = await axios.get(url);
                setColores(resultado.data);
                setVehiculoColor(resultado.data[0].VAC_COLOR);
                setColorNombre(resultado.data[0].COL_NOMBRE);
                let imgColor = require(`../../images/colores/${modeloEnviar}/${resultado.data[0].VAC_COLOR}.webp`);
                setImagen(imgColor);
            };
            getColores(infoFinal[6], infoFinal[0]);
            let sel = document.getElementById("version");
            setVersionNombre(sel.options[sel.selectedIndex].text);
        };
        if (versiones.length < 1) {
            getVersiones(modeloEnviar);
        }
        // Ciudades
        const getCiudades = async () => {
            const url = `${Server}/api/ciudades/1/1-3/2`;
            const resultado = await axios.get(url);
            setCiudades(resultado.data);
        };
        if (ciudades.length < 1) {
            getCiudades();
        }
        // Token
        const parsed = queryString.parse(datos.location.search);
        if (parsed.tk === "" || parsed.tk === undefined) {
            // si no tiene token es por default

            setToken("981ca38f59");
        } else {
            // 
            setToken(parsed.tk);
        }
        setUtmSource(parsed.utm_source || "");
        setUtmMedium(parsed.utm_medium || "");
        setUtmCampaign(parsed.utm_campaign || "");
        setUtmTerm(parsed.utm_term || "");
        setUtmContent(parsed.utm_content || "");
    }, [
        modeloNombre,
        datos.location.search,
        modelo,
        ciudades.length,
        versiones.length,
        datos.location.search,
    ]);

    return (
        <Fragment>
            <link rel="preload" as="image" href={grandi10sedanImg} />
            <link rel="preload" as="image" href={ioniqImg} />
            <link rel="preload" as="image" href={grandi10hbImg} />
            <link rel="preload" as="image" href={santafeImg} />
            <link rel="preload" as="image" href={konaImg} />
            <link rel="preload" as="image" href={NuevoAccentImg} />
            <link rel="preload" as="image" href={StariaImg} />
            <link rel="preload" as="image" href={KonaElectricoImg} />
            <Container className="cotizatuhyundai  my-3 my-md-4">
                <Form onSubmit={handleSubmit} id="formCotizador">
                    <Form.Row>
                        <Form.Group as={Col} md="9" lg="7">
                            <Form.Row>
                                <Form.Group
                                    as={Col}
                                    md="6"
                                    className="cont-version mb-0 mb-md-0"
                                >
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" className="mb-0">
                                            <Form.Label className="paso-label-cotizador">
                                                <span className="numero-paso">1</span> <h1>Seleccione un
                                                    modelo</h1>
                                            </Form.Label>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" className="pl-md-5">
                                            <Form.Control
                                                as="select"
                                                name="version"
                                                id="version"
                                                className="select-version pl-4"
                                                defaultValue={0}
                                                required
                                                onChange={leerVersion}
                                            >
                                                <option disabled value={0} key={0}>
                                                    - Modelo -
                                                </option>
                                                {versiones.map((version) => (
                                                    <option
                                                        key={version.VER_CODIGO}
                                                        value={
                                                            version.VER_CODIGO +
                                                            "|" +
                                                            version.VEA_ANIO +
                                                            "|" +
                                                            version.VEA_PRECIO_PVP +
                                                            "|" +
                                                            version.VEA_BONO +
                                                            "|" +
                                                            version.VEA_PRECIO_FINAL +
                                                            "|" +
                                                            version.VER_COD_SGC +
                                                            "|" +
                                                            version.MOD_CODIGO
                                                        }
                                                    >
                                                        {version.MOD_NOMBRE}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                </Form.Group>
                                <Form.Group as={Col} md="6" className="mb-md-0">
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" className="mb-0">
                                            <Form.Label className="paso-label-cotizador" id="labelColor">
                                                <span className="numero-paso">2</span> <h1>Seleccione un
                                                    color</h1>
                                            </Form.Label>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row style={{ height: "40px", overflow: "hidden" }}>
                                        <Form.Group as={Col} md="12" className="mb-0">
                                            <div className="color-option text-center">
                                                <ul>
                                                    {colores.map((color) => (
                                                        <li
                                                            value={color.COL_NOMBRE}
                                                            key={color.VAC_COLOR}
                                                            id="nombre-color"
                                                            style={{
                                                                backgroundColor: `${color.COL_REF_HEX}`,
                                                            }}
                                                            onClick={() => {
                                                                coloresModelos(
                                                                    color.VAC_COLOR,
                                                                    color.COL_NOMBRE
                                                                );
                                                            }}
                                                        ></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" className="mb-0">
                                            <div className="text-center">
                                                {colorNombre !== "" ?
                                                    <span className="label-color">{colorNombre}</span> : null}
                                            </div>
                                        </Form.Group>
                                    </Form.Row>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row className="d-block d-md-block">
                                <Form.Group as={Col} md="12" className="mb-0">
                                    <Image
                                        className="animacion-imagen"
                                        src={imagen}
                                        title={modeloNombre}
                                        alt={modeloNombre}
                                        fluid
                                        id="color-modelo"
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row className="precio-mobile d-block d-md-none d-flex">
                                {bono === 0 ? (
                                    ""
                                ) : (
                                    <Form.Group
                                        as={Col}
                                        xs="6"
                                        className="mx-auto d-md-flex justify-content-center mt-2"
                                    >
                                        <div>
                                            <p className="label-bono mb-0">
                                                Precio{" "}
                                                <span className="precio-bono">
                                                    <NumberFormat
                                                        value={precio}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        prefix={"$"}
                                                    />
                                                </span>
                                            </p>
                                            <p className="titulo-bono mb-0">Bono promocional*</p>
                                            <div className="bono-cont mt-1">
                                                <div className="d-flex align-items-center">
                                                    {/* <span className="dollar my-auto">$</span> */}
                                                    <span className="valor-bono">
                                                        <NumberFormat
                                                            value={bono}
                                                            displayType={"text"}
                                                            thousandSeparator={true}
                                                            prefix={"$"}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                )}
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="6" className="mb-1 mb-md-0">
                                    <Form.Label className="paso-label-cotizador">
                                        <span className="numero-paso">3</span> <h1>Llene sus datos</h1>
                                    </Form.Label>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="6" className="pl-md-5">
                                    <Form.Control
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        placeholder="Nombre"
                                        required
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" className="pr-md-5">
                                    <Form.Control
                                        type="text"
                                        id="apellido"
                                        name="apellido"
                                        placeholder="Apellido"
                                        required
                                        value={apellido}
                                        onChange={(e) => setApellido(e.target.value)}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="6" className="pl-md-5">
                                    <InputMask
                                        type="text"
                                        id="cedula"
                                        name="cedula"
                                        placeholder="Cédula"
                                        required
                                        value={cedula}
                                        className="form-control"
                                        onChange={(e) => setCedula(e.target.value)}
                                        mask="9999999999"
                                        maskChar=" "
                                        onBlur={blurCedula}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" className="pr-md-5">
                                    <Form.Control
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="6" className="pl-md-5">
                                    <InputMask
                                        type="text"
                                        id="telefono"
                                        name="telefono"
                                        placeholder="Celular"
                                        className="form-control"
                                        required
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                        mask="099 999 9999"
                                        maskChar=" "
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" className="pr-md-5">
                                    <Form.Control
                                        as="select"
                                        name="ciudad"
                                        id="ciudad"
                                        className="custom-select"
                                        value={ciudad}
                                        onChange={leerCiudad}
                                    >
                                        <option disabled value={0} key={0}>
                                            - Ciudad -
                                        </option>
                                        {ciudades.map((ciudad) => (
                                            <option key={ciudad.CIU_CODIGO} value={ciudad.CIU_CODIGO}>
                                                {ciudad.CIU_NOMBRE}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="6" className="pl-md-5">
                                    <Form.Control
                                        as="select"
                                        name="concesionario"
                                        id="concesionario"
                                        className="custom-select"
                                        required
                                        value={concesionario}
                                        onChange={leerConcesionario}
                                    >
                                        <option disabled value={0} key={0}>
                                            - Concesionario -
                                        </option>
                                        {Object.keys(concesionarios).length > 0
                                            ? concesionarios.map((concesionario) => (
                                                <option
                                                    key={
                                                        concesionario.ALM_EMPRESA +
                                                        "|" +
                                                        concesionario.ALM_CODIGO
                                                    }
                                                    value={
                                                        concesionario.ALM_EMPRESA +
                                                        "|" +
                                                        concesionario.ALM_CODIGO +
                                                        "|" +
                                                        concesionario.ALM_DIRECCION +
                                                        "|" +
                                                        concesionario.ALM_TELEFONO +
                                                        "|" +
                                                        concesionario.ALM_HORARIO_LUN_VIER +
                                                        "|" +
                                                        concesionario.ALM_HORARIO_SAB +
                                                        "|" +
                                                        concesionario.ALM_MAPAS_URL +
                                                        "|" +
                                                        concesionario.ALM_COD_SGC
                                                    }
                                                >
                                                    {concesionario.EMP_NOMBRE_COMERCIAL}/
                                                    {concesionario.ALM_NOMBRE}
                                                </option>
                                            ))
                                            : null}
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="6" className="pr-md-5">
                                    <Form.Check
                                        className="condiciones text-center"
                                        label="Acepto los términos y condiciones."
                                        id="acepto"
                                        name="acepto"
                                        onChange={leerAcepto}
                                        value={acepto}
                                        defaultChecked={acepto}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row className="d-block d-sm-none">
                                <Form.Group as={Col} md="12" className="text-center">
                                    <Form.Label className="paso-label-cotizador mr-2">
                                        <span className="numero-paso">4</span>
                                    </Form.Label>
                                    {activeSpinner ? (
                                        <Spinner />
                                    ) : (
                                        <Button
                                            variant="primary mt-md-2 p-2"
                                            type="submit"
                                            className="btn-cotizar"
                                            disabled={!formEsValido()}
                                        >
                                            Cotizar
                                            <Image
                                                src={Enviar}
                                                alt="Enviar icono"
                                                className="plane-icon ml-2"
                                                fluid
                                            />
                                        </Button>
                                    )}
                                </Form.Group>
                            </Form.Row>
                            <Form.Row className="d-none d-sm-block">
                                <Form.Group as={Col} md="12">
                                    <Form.Label className="paso-label-cotizador mr-2">
                                        <span className="numero-paso">4</span>
                                    </Form.Label>
                                    {activeSpinner ? (
                                        <Spinner />
                                    ) : (
                                        <Button
                                            type="submit"
                                            variant="primary py-2 px-1 ml-md-3"
                                            className="btn-cotizar"
                                            disabled={!formEsValido()}
                                        >
                                            Cotizar
                                            <Image
                                                src={Enviar}
                                                alt="Enviar icono"
                                                className="plane-icon ml-2"
                                            />
                                        </Button>
                                    )}
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="12 pl-md-5">
                                    <h2 className="titulo-legal mt-2 pl-md-4">
                                        Términos y condiciones
                                    </h2>
                                    <h3 className="texto-legal pr-md-3 pl-md-4">
                                        Autorizo de manera expresa, inequívoca y voluntaria a HYUNDAI ECUADOR y todas sus
                                        compañías relacionadas, para recopilar, tratar, transferir a terceros y conservar
                                        mis datos personales y crediticios, así como para su revisión ante el buró de crédito
                                        con la finalidad de cotizar el vehículo, y recibir comunicaciones o notificaciones
                                        sobre sus productos y servicios. Además los valores calculados son referenciales y
                                        bajo ninguna circunstancia representan un compromiso de venta.
                                        Estos valores están sujetos a variaciones. Las fotografías son referenciales,
                                        el modelo y accesorios pueden variar en el punto de venta.
                                    </h3>
                                </Form.Group>
                            </Form.Row>
                        </Form.Group>
                        <Form.Group as={Col} md="3" lg="5" className="vehiculo-precio-box d-none d-md-flex flex-column align-items-center justify-content-center">
                            <div className="vehiculo-precio-inner text-center">
                                <Image className="img-ve" src={imagen} alt="Hyundai vehiculo" style={{ minHeight: "265px", overflow: "hidden" }} />
                                
                            </div>
                        </Form.Group>
                    </Form.Row>
                </Form>
            </Container>
            <br />
        </Fragment>
    );
}
export default FormCotizaTuHibrido;